import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-32 md:py-48 relative bg-background" data-id="element-14">
      <div className="container mx-auto px-6 md:px-12" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0" data-id="element-16">
          <div className="lg:col-span-4 flex flex-col justify-between" data-id="element-17">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} data-id="element-18">
              <h2 className="text-gold uppercase tracking-[0.2em] text-sm font-sans mb-4" data-id="element-19">
                Про агенцію
              </h2>
              <div className="w-12 h-[1px] bg-gold/50" data-id="element-20"></div>
            </motion.div>

            <motion.div className="hidden lg:block mt-auto" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.4
          }} data-id="element-21">
              <p className="text-ivory/50 font-sans text-sm uppercase tracking-widest leading-relaxed" data-id="element-22">
                Засновано в Києві
                <br data-id="element-23" />
                Працюємо по всьому світу
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-8" data-id="element-24">
            <motion.h3 className="text-3xl md:text-5xl lg:text-6xl font-serif leading-tight text-ivory" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-25">
              Ми не просто організовуємо події. Ми створюємо{' '}
              <span className="italic text-gold" data-id="element-26">архітектуру вражень</span>.
              Кожна деталь продумана, кожна емоція зрежисована.
            </motion.h3>

            <motion.div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 text-ivory/70 font-sans font-light text-lg leading-relaxed" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-27">
              <p data-id="element-28">
                Наша філософія базується на бездоганному сервісі та естетиці
                преміум-класу. Ми віримо, що справжня розкіш полягає в
                непомітних деталях та ідеальному таймінгу.
              </p>
              <p data-id="element-29">
                Маючи понад 10 років досвіду, ми зібрали команду
                перфекціоністів, які перетворюють найсміливіші ідеї на
                бездоганну реальність, незалежно від масштабу чи локації.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}